// // Filename - App.js

// import React, { useState, useRef, useEffect } from "react";

import React, { useState, useEffect, useRef } from "react";

interface CountdownTimerProps {
  duration: number;
  timerExpired: () => void;
}

export default function CountDownTimer(props: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(props.duration);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setTimeLeft(props.duration); // Reset the timer when the duration prop changes
  }, [props.duration]);

  useEffect(() => {
    if (timeLeft <= 0) {
      props.timerExpired();
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
      periodicFunction(); // Call the periodic function every second
    }, 1000);

    timerRef.current = timer;

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

  // function resetTimer() {
  //   if (timerRef.current) clearInterval(timerRef.current);
  //   setTimeLeft(props.duration);
  // }

  function periodicFunction() {
    console.log("Periodic function executed");
    // Add your periodic logic here
  }

  return (
    <div className="text-center p-2 border rounded-lg bg-gray-100">
      {timeLeft === 0 ? (
        <div>
          <h1 className="text font-bold">Code Expired</h1>
        </div>
      ) : (
        <div>
          <h1 className="font-bold">Code Expiring In</h1>
          <p className="">{formatTime(timeLeft)}</p>
        </div>
      )}
    </div>
  );
}

// export default function CountDownTimer() {
//   // We need ref in this, because we are dealing
//   // with JS setInterval to keep track of it and
//   // stop it when needed
//   const Ref = useRef(null);

//   // The state for our timer
//   const [timer, setTimer] = useState("00:00:00");

//   const getTimeRemaining = (e: string) => {
//     const total = Date.parse(e) - Date.parse(Date());
//     const seconds = Math.floor((total / 1000) % 60);
//     const minutes = Math.floor((total / 1000 / 60) % 60);
//     const hours = Math.floor((total / 1000 / 60 / 60) % 24);
//     return {
//       total,
//       hours,
//       minutes,
//       seconds,
//     };
//   };

//   function startTimer(e: string) {
//     let { total, hours, minutes, seconds } = getTimeRemaining(e);
//     if (total >= 0) {
//       // update the timer
//       // check if less than 10 then we need to
//       // add '0' at the beginning of the variable
//       setTimer(
//         (hours > 9 ? hours : "0" + hours) +
//           ":" +
//           (minutes > 9 ? minutes : "0" + minutes) +
//           ":" +
//           (seconds > 9 ? seconds : "0" + seconds)
//       );
//     }
//   }

//   function clearTimer(e: string) {
//     // If you adjust it you should also need to
//     // adjust the Endtime formula we are about
//     // to code next
//     setTimer("00:00:10");

//     // If you try to remove this line the
//     // updating of timer Variable will be
//     // after 1000ms or 1sec
//     if (Ref.current) clearInterval(Ref.current);
//     const id = setInterval(() => {
//       startTimer(e);
//     }, 1000);
//     //Ref.current = id;
//   }

//   function getDeadTime() {
//     let deadline = new Date();

//     // This is where you need to adjust if
//     // you entend to add more time
//     deadline.setSeconds(deadline.getSeconds() + 10);
//     return deadline;
//   }

//   // We can use useEffect so that when the component
//   // mount the timer will start as soon as possible

//   // We put empty array to act as componentDid
//   // mount only
//   useEffect(() => {
//     clearTimer(getDeadTime());
//   }, []);

//   // Another way to call the clearTimer() to start
//   // the countdown is via action event from the
//   // button first we create function to be called
//   // by the button
//   function resetTimer() {
//     clearTimer(getDeadTime());
//   }

//   return (
//     <div style={{ textAlign: "center", margin: "auto" }}>
//       <h3>Countdown Timer Using React JS</h3>
//       <h2>{timer}</h2>
//     </div>
//   );
// }
